import { useEffect, useRef, useState } from 'react';

import classNames from 'classnames';
import { SLUGS } from 'helpers/consts';
import { getHtml, renderHtml } from 'helpers/helpers';
import { useSettingsReady } from 'hooks/useAppReadiness';
import { useAppSettings } from 'selectors/appSettingsSelectors';
import { useUser } from 'selectors/userSelectors';

import './StaticPage.scss';

type StaticPageProps = {
  slug?: string;
  className?: string;
};

export default function StaticPage(props: StaticPageProps) {
  const { slug = SLUGS.FRONT, className } = props;

  const { locale } = useUser();
  const { settings } = useAppSettings();
  const settingsReady = useSettingsReady();

  const [content, setContent] = useState<string>('');
  const scrollableRef = useRef<HTMLDivElement>(null!);

  useEffect(() => {
    // Wait for settings to be initialized before using settings data
    if (!settingsReady) return;

    async function getContent() {
      const html = await getHtml(slug, locale);
      setContent(html);
    }
    getContent();
  }, [slug, locale, settings?.rights?.guestTryout, settingsReady]);

  useEffect(() => {
    // add email address where required
    const m = document.getElementById('mContainer');
    if (m && m instanceof HTMLAnchorElement) {
      let email = 'ln.negolaidekeilbup@ofni'.split('').reverse().join('');
      m.href = 'mailto:' + email;
      m.textContent += ' ' + email;
    }
    // add event listener for unmuting video
    if (scrollableRef.current && content && content !== '') {
      const videoElement = scrollableRef.current.querySelector('video');
      if (videoElement) {
        const toggleMute = (event: Event) => {
          const video = event.currentTarget as HTMLVideoElement;
          if (video.muted) {
            video.muted = false;
            video.volume = 1.0;
            video.title = 'Click to mute';
          } else {
            video.muted = true;
            video.title = 'Click to unmute';
          }
        };
        videoElement.addEventListener('click', toggleMute);
        return () => {
          videoElement.removeEventListener('click', toggleMute);
        };
      }
    }
  }, [content]);

  return (
    <div className={classNames('static_page', className)}>
      <div className="page_container">
        <div className="page_content" ref={scrollableRef}>
          {renderHtml(content)}
        </div>
      </div>
    </div>
  );
}
